/**
 * Where the shareable profile lives: the landing site (Marzouki-Landing), which
 * renders `/p/<slug>`. The API no longer serves profile pages, only the preview
 * card image behind them, so this must never point at the API host.
 *
 * The link is absolute because the landing is a different origin — a relative
 * `/p/<slug>` from here would resolve to the console, which has no such route.
 *
 * The default is the landing's local dev port. On QA this is
 * `https://qa.kader-sport.com`, in production `https://kader-sport.com`.
 *
 * Read from `import.meta.env`, not `process.env`. There is no Node here — this
 * module is evaluated in a browser, where `process` is undefined and reaching for
 * it is a `ReferenceError` that takes down the whole talents table. Vite inlines
 * `VITE_*` at build time; nothing else is visible. `no-server-globals.spec.ts`
 * keeps the next one from getting in.
 */
const PUBLIC_WEB_ORIGIN = (import.meta.env.VITE_PUBLIC_WEB_URL ?? 'http://localhost:3003').replace(
  /\/$/,
  '',
);

export function publicProfileUrl(slug: string): string {
  return `${PUBLIC_WEB_ORIGIN}/p/${encodeURIComponent(slug)}`;
}
